import type {
  ProductListItem,
  TaskFrame,
} from "@labeling-tools/api/field-rep/generated/types.gen";
import { ProductProposal, TrackFrame } from "@/types/trackLabeling";
import { toRecognizerProposal } from "@/utils/productSet";
import {
  aggregateFrameProposals,
  sanitizeNormalizedFramePoints,
} from "./utils";

export const toTrackFrames = (
  frames: TaskFrame[],
  missingImagePlaceholder: string,
): TrackFrame[] =>
  frames.map((frame) => ({
    fileName: frame.image_id,
    imageUrl: frame.image_url || missingImagePlaceholder,
    points: sanitizeNormalizedFramePoints(frame.points),
  }));

export const toFrameProducts = (
  frames: TaskFrame[],
  endFrame: number,
  products: ProductListItem[],
): ProductProposal[] => {
  const productsById = new Map(
    products.map((product) => [product.id, product]),
  );

  return aggregateFrameProposals(frames, endFrame).proposals.flatMap(
    (proposal) => {
      const product = productsById.get(proposal.product_id);
      return product
        ? [toRecognizerProposal(product, proposal.final_score)]
        : [];
    },
  );
};
